<form [formGroup]="form" (ngSubmit)="submit()" *ngIf="profile">
  <mat-card class="mat-elevation-z">
    <mat-form-field>
      <mat-label>Adresse email</mat-label>
      <input mat-input matInput formControlName="email" [value]="form.get('email').value">
      <mat-error *ngIf="form.hasError('required','email')">The Email is required</mat-error>
    </mat-form-field>

    <mat-form-field disabled>
      <mat-label>Numéro de téléphone</mat-label>
      <input matInput formControlName="phone" [value]="form.get('phone').value">
      <mat-error *ngIf="form.hasError('required','phone')">The phoneNumber is required</mat-error>
    </mat-form-field>

    <mat-error *ngIf="form.hasError('unauthorized')">Wrong login/password</mat-error>

    <mat-card-actions>
    </mat-card-actions>
  </mat-card>
</form>